const STORAGE_KEY_DISMISSED = "trirebels-newsletter-dismissed-at";
const STORAGE_KEY_SUBSCRIBED = "trirebels-newsletter-subscribed";

/** Justera hur ofta nyhetsbrevsmodalen visas. */
export const NEWSLETTER_MODAL_CONFIG = {
  /** Väntetid efter sidladdning innan modalen kan visas (ms). */
  delayMs: 5000,
  /** Antal dagar innan modalen visas igen efter att användaren stängt den. */
  cooldownDays: 14,
  /** Sidor där modalen aldrig visas (prefix-match). */
  excludedPathPrefixes: ["/checkout", "/order", "/track"],
};

function readTimestamp(key: string): number | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return null;
    const value = Number(raw);
    return Number.isFinite(value) ? value : null;
  } catch {
    return null;
  }
}

function writeTimestamp(key: string, value: number): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(key, String(value));
  } catch {
    // localStorage kan vara otillgängligt (t.ex. privat läge)
  }
}

export function markNewsletterSubscribed(): void {
  writeTimestamp(STORAGE_KEY_SUBSCRIBED, Date.now());
}

export function markNewsletterDismissed(): void {
  writeTimestamp(STORAGE_KEY_DISMISSED, Date.now());
}

export function hasNewsletterSubscribed(): boolean {
  return readTimestamp(STORAGE_KEY_SUBSCRIBED) !== null;
}

export function shouldShowNewsletterModal(pathname: string): boolean {
  if (hasNewsletterSubscribed()) return false;

  const { excludedPathPrefixes, cooldownDays } = NEWSLETTER_MODAL_CONFIG;
  if (excludedPathPrefixes.some((prefix) => pathname.startsWith(prefix))) {
    return false;
  }

  const dismissedAt = readTimestamp(STORAGE_KEY_DISMISSED);
  if (dismissedAt === null) return true;

  const cooldownMs = cooldownDays * 24 * 60 * 60 * 1000;
  return Date.now() - dismissedAt >= cooldownMs;
}
